/**
 * Csv Schema of EmailDestinatario
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {EmailDestinatario} from '@/model/resource/EmailDestinatario'

/* TODO: review generated schema */
export class CsvEmailDestinatarioSchema extends Schema {
  readonly name = 'CsvEmailDestinatario'

  readonly fieldSet: FieldSet<EmailDestinatario> = {
    idEmailDestinatarioPk: schema => schema.model.idEmailDestinatarioPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    cpfCnpj: schema => schema.model.cpfCnpj,
    email: schema => schema.model.email,
  }
}
